import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { reduxKey } from './constants';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { getUserById } from '../redux/users/selectors';
import { flagEnabled } from '../redux/flags/selectors';
import { HubChannel } from '../redux/hub/types';
import { createSelector } from 'reselect';
import get from 'lodash/get';
export const getPublicSession = (state)=>{
    const publicSession = state && state[reduxKey] ? state[reduxKey] : {};
    let user;
    if (publicSession.user) {
        if (typeof publicSession.user === 'object') {
            user = publicSession.user;
        } else {
            user = getUserById(state, publicSession.user);
        }
    }
    return _object_spread_props(_object_spread({}, publicSession), {
        user
    });
};
export const getCsrfToken = (state)=>getPublicSession(state).csrfToken;
export const getIsMobile = (state)=>getPublicSession(state).isMobile;
export const getIsIOS = (state)=>{
    var _getPublicSession_device;
    return !!((_getPublicSession_device = getPublicSession(state).device) === null || _getPublicSession_device === void 0 ? void 0 : _getPublicSession_device.isIos);
};
export const getPagingMode = (state)=>getPublicSession(state).pagingMode === 'page' ? 'page' : 'scroll';
export const getPageSize = (state)=>get(getPublicSession(state), 'pageSize', 24);
export const getIsLoggedIn = (state)=>getPublicSession(state).isLoggedIn;
export const getIsVerificationNeeded = (state)=>getIsLoggedIn(state) && !getPublicSession(state).isVerified;
export const getIsVerified = (state)=>getIsLoggedIn(state) && getPublicSession(state).isVerified;
export const getIsUnverified = (state)=>getIsLoggedIn(state) && getPublicSession(state).isUnverified;
export const getVerificationEmailAddress = (state)=>getPublicSession(state).verificationEmail;
export const getCurrentUser = (state)=>{
    const publicSession = getPublicSession(state);
    return publicSession.user;
};
export const getCurrentUserId = (state)=>{
    const currentUser = getCurrentUser(state);
    return currentUser && currentUser.userId;
};
export const getSeo = (state)=>getPublicSession(state).seo;
export const getSeoCanonical = (state)=>{
    const seo = getSeo(state);
    return seo && seo.canonical;
};
export const getSeoTitle = (state)=>{
    const seo = getSeo(state);
    return seo && seo.title ? seo.title : 'DeviantArt - Discover The Largest Online Art Gallery and Community';
};
export const getSeoDescription = (state)=>{
    const seo = getSeo(state);
    return seo && seo.description;
};
export const getSeoPrevUrl = (state)=>{
    var _getSeo;
    return (_getSeo = getSeo(state)) === null || _getSeo === void 0 ? void 0 : _getSeo.prev;
};
export const getSeoNextUrl = (state)=>{
    var _getSeo;
    return (_getSeo = getSeo(state)) === null || _getSeo === void 0 ? void 0 : _getSeo.next;
};
export const getSeoRating = (state)=>{
    var _getSeo;
    return (_getSeo = getSeo(state)) === null || _getSeo === void 0 ? void 0 : _getSeo.rating;
};
export const getCounts = (state)=>getPublicSession(state).counts;
export const getWatchCount = (state)=>getCounts(state) && getCounts(state).watch || 0;
export const getNotesCount = (state)=>getCounts(state) && getCounts(state).notes || 0;
export const getFeedbackCount = (state)=>getCounts(state) && getCounts(state).feedback || 0;
export const getFeedbackUrl = (state)=>getPublicSession(state).feedbackUrl || '';
export const getCartCount = (state)=>getCounts(state) && getCounts(state).cart || 0;
export const getTierСount = (state)=>getCounts(state) && getCounts(state).tiers || 0;
export const getPointsCount = (state)=>getCounts(state) && getCounts(state).points || 0;
export const getDywHasNew = (state)=>getCounts(state) && getCounts(state).dywHasNew || false;
export const getCurrentUserHasCore = (state)=>getPublicSession(state).hasCoreMembership;
export const getCoreLevel = (state)=>getPublicSession(state).coreLevel;
export const getHasJoinedWithEclipse = (state)=>getPublicSession(state).hasJoinedWithEclipse;
export function getViewMode(state) {
    return getPublicSession(state).deviationViewMode;
}
export const getHubState = (state)=>getPublicSession(state).hub;
export const getHasAcceptedCookies = (state)=>getPublicSession(state).hasAcceptedCookies;
export const getCookieSettings = (state)=>getPublicSession(state).cookiePrivacySettings;
export const getCookiePrivacyRequired = (state)=>getPublicSession(state).cookiePrivacyRequired;
export const getIsCookieBannerVisible = (state)=>getCookiePrivacyRequired(state) && !getHasAcceptedCookies(state);
export const getLiveNotificationsEnabled = (state)=>{
    const hubState = getHubState(state);
    const subs = hubState && hubState.subs;
    var _subs_some;
    return (_subs_some = subs === null || subs === void 0 ? void 0 : subs.some((sub)=>sub.startsWith(`${HubChannel.NOTIFICATIONS}#`))) !== null && _subs_some !== void 0 ? _subs_some : false;
};
export const getDRE = (state)=>getPublicSession(state).dre;
export const getShowMatureContent = createSelector([
    getPublicSession
], (session)=>session.showMatureContent);
export const getContentFilter = createSelector([
    getPublicSession
], (session)=>session.contentFilter);
export const isUserOlderThan18 = createSelector([
    getCurrentUser
], (user)=>get(user, 'details.age', 0) >= 18);
export const getCurrentUserCommentsOrder = createSelector([
    getPublicSession
], (session)=>{
    if (!session || !session.commentsOrder) {
        return 'newest';
    }
    return session.commentsOrder;
});
export const getTheme = createSelector([
    getPublicSession
], (session)=>session && session.theme || ThemeOptions.DARK);
export const getThemeSkin = createSelector([
    getPublicSession
], (session)=>session && session.themeSkin);
export const getPageThumb = createSelector([
    getPublicSession
], (session)=>get(session, 'seo.socialThumbSrc'));
export const getVerificationLoadingState = createSelector([
    getPublicSession
], ({ updateProgress ={}  })=>({
        isResendInProgress: !!updateProgress.isResendInProgress,
        isEmailChangeInProgress: !!updateProgress.isEmailChangeInProgress,
        isSendingDone: !!updateProgress.isSendingDone,
        updateFailed: !!updateProgress.updateFailed
    }));
export const getIsEclipseSwitcherEnabled = createSelector([
    getPublicSession
], (session)=>{
    if (!session || !session.eclipseSwitcher) {
        return false;
    }
    return session.eclipseSwitcher;
});
export const getDeviceSupportsWebp = (state)=>{
    const publicSession = getPublicSession(state);
    var _get;
    return (_get = get(publicSession, 'device.supportsWebp')) !== null && _get !== void 0 ? _get : false;
};
export const getDeviceSupportsLazy = (state)=>{
    const publicSession = getPublicSession(state);
    var _get;
    return (_get = get(publicSession, 'device.supportsLazy')) !== null && _get !== void 0 ? _get : false;
};
// Chat
export const getChatIsMuted = (state)=>{
    const publicSession = getPublicSession(state);
    return get(publicSession, 'chat.muted', false) === true;
};
export const getChatOnlineState = (state)=>{
    const publicSession = getPublicSession(state);
    return get(publicSession, 'chat.online', true);
};
export const getChatSoundsMuted = (state)=>{
    const publicSession = getPublicSession(state);
    return get(publicSession, 'chat.muteSound', false);
};
export const getFragmentsBalance = (state)=>{
    const counts = getCounts(state);
    const defaultBalance = flagEnabled(state, 'eclipse_debug') ? 1000 : 0;
    var _counts_fragments;
    return (_counts_fragments = counts === null || counts === void 0 ? void 0 : counts.fragments) !== null && _counts_fragments !== void 0 ? _counts_fragments : defaultBalance;
};
export const getCanUserSeeWatch = (state)=>{
    // T58152: Enable old watch for all users
    return getPublicSession(state).isLoggedIn;
};
export const getPromos = createSelector([
    getPublicSession
], (session)=>{
    return session === null || session === void 0 ? void 0 : session.promos;
});
export const getLimitedBadgesPromo = createSelector([
    getPublicSession
], (session)=>{
    return session === null || session === void 0 ? void 0 : session.limitedBadgesPromo;
});
export const getAdsEnabled = createSelector([
    getPublicSession
], (session)=>{
    return session === null || session === void 0 ? void 0 : session.adsEnabled;
});
